import { ClipLoader } from 'react-spinners'
import { colors } from '../../services/styles'

export function SL_ClipLoader(props) {
    return <ClipLoader color={colors.primary} size={50} {...props} />
}
